import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { SortableColumnVisibilityRow } from './SortableColumnVisibilityRow';

interface ColumnVisibilityItem {
  key: string;
  label: string;
}

interface DataTableColumnVisibilityListProps<T extends ColumnVisibilityItem> {
  items: string[];
  columns: T[];
  visibleKeys: string[];
  onToggle: (key: string) => void;
}

export function DataTableColumnVisibilityList<T extends ColumnVisibilityItem>({
  items,
  columns,
  visibleKeys,
  onToggle,
}: DataTableColumnVisibilityListProps<T>) {
  return (
    <div className="flex-1 overflow-y-auto px-5 py-4 space-y-1">
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {columns.map((column) => (
          <SortableColumnVisibilityRow
            key={column.key}
            column={column}
            visible={visibleKeys.includes(column.key)}
            onToggle={() => onToggle(column.key)}
          />
        ))}
      </SortableContext>
    </div>
  );
}
